export default __webpack_public_path__ + "static/media/powered-by-seedooh.efd22ca4.svg";